import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IframeCloseIconComponent} from './iframe-close-icon.component';
import {ConfigModule, I18nModule} from '@spartacus/core';

@NgModule({
  declarations: [
    IframeCloseIconComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        IframeCloseIconComponent: {
          component: IframeCloseIconComponent,
        }
      }
    }),
    I18nModule,
  ],
  exports: [
    IframeCloseIconComponent,
  ],
})
export class IframeCloseIconModule {
}
